import bridge from '@vkontakte/vk-bridge';
import { createEffect } from 'effector';
import { IAppLaunchParams } from '../../model/types';

export const getAppLaunchParamsFx = createEffect<void, IAppLaunchParams, Error>(async () => {
  try {
    const data = await bridge.send('VKWebAppGetLaunchParams');
    if (data.vk_app_id) {
      return data;
    }
    throw new Error('Не удалось получить id пользователя');
  } catch (error: any) {
    throw new Error(error);
  }
});
